// Use DefinePlugin (Webpack) or loose-envify (Browserify)
// together with Uglify to strip the dev branch in prod build.
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./createStore.prod').default;
} else {
  module.exports = require('./createStore.dev').default;
}



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/redux/createStore.js
 ** module id = 232
 ** module chunks = 0
 **/